export default {
  methods: {
    getFormattedDate(minusDays) {
      const d = new Date()
      d.setDate(d.getDate() - minusDays)
      return this.formatDate(d)
    },
    formatDate(date) {
      const year = date.getFullYear()
      let month = date.getMonth() + 1
      if (month < 10) {
        month = '0' + month
      }
      let day = date.getDate()
      if (day < 10) {
        day = '0' + day
      }
      return year + '-' + month + '-' + day
    },
    getDateFromDateTimeString(dateStr) {
      if (!dateStr || dateStr == null) {
        return 'brak danych'
      } else {
        return dateStr.substring(0, 10)
      }
    }
  }
}
